import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const addaPage = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  query AddaPage($locale: SiteLocale) {
    metodoAdda(locale: $locale) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
      intro {
        id
        testoSinistra
        testoDestra
        titolo
        landscape: immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        portrait: immagine {
          responsiveImage(imgixParams: { auto: compress, q: "50", ar: "1:1" }) {
            ...ResponsiveImageFragment
          }
        }
      }
      adda {
        titolo
        testo
        immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
      }
      titoloSezioneModelli
      modelliProgettuali {
        titolo
        testo
        id
      }
      bloccoSovrapposto {
        testoDestra
        immagineSinistra {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        cta {
          testo
          link
        }
      }
    }
    allListaAmbitis(locale: $locale) {
      _allSlugLocales {
        value
        locale
      }
      slug
      titolo
      testo
    }
  }
`
